module.exports = s => '$' + s.toFixed(2).replace(/\d(?=(\d{3}) +\.)/g, '$&,');